import { useState } from "react";

export const useDeliveryOptions = () => {
  const [deliveryOption, setDeliveryOption] = useState<"asap" | "date">("date");
  const [deliveryDate, setDeliveryDate] = useState<Date | undefined>(undefined);
  const [requestedDeliveryDateStart, setRequestedDeliveryDateStart] = useState<
    Date | undefined
  >(undefined);
  const [requestedDeliveryDateEnd, setRequestedDeliveryDateEnd] = useState<
    Date | undefined
  >(undefined);

  return {
    deliveryOption,
    setDeliveryOption,
    deliveryDate,
    setDeliveryDate,
    requestedDeliveryDateStart,
    setRequestedDeliveryDateStart,
    requestedDeliveryDateEnd,
    setRequestedDeliveryDateEnd,
  };
};
